import React from "react";

import { EmbeddedLink } from "../../ui/EmbeddedLink";
import { Medium } from "../../ui/Typography/Span";

export const LinkFormatting = (linkTo: string) =>
  function (chunks: JSX.Element) {
    return <EmbeddedLink linkTo={linkTo}>{chunks}</EmbeddedLink>;
  };

export const ClickableFormatting = (onClick: () => void) =>
  function (chunks: JSX.Element) {
    return <EmbeddedLink onClick={onClick}>{chunks}</EmbeddedLink>;
  };

export const MediumFormatting = (chunks: JSX.Element) => (
  <Medium>{chunks}</Medium>
);
